<div id="addcontent" class="dataContent container" value="1">
    <div class="node-wrap start-node" [style.width.px]="diagramNodeWidth">
        <div class="node-wrap-box">
            <div class="node-wrap-body" (click)="onStart()"
                [ngClass]="{'border-color-error': this.config.invalidSetting}">Start
            </div>
        </div>
        <div class="add-node-btn-box">
            <div class="add-node-btn">
                <button #addButton class="btn" type="button" (click)="showTaskActionContextMenu($event,addButton)">
                    <smart-icon name="add-square" class="add-icon"></smart-icon>
                </button>
            </div>
        </div>
    </div>
    <ng-container *ngIf="nodes && nodes.roots && nodes.roots.length > 0">
        <tam-diagram-node *ngFor="let node of nodes.roots" [nodeId]="node.guid"></tam-diagram-node>
    </ng-container>
    <div class="node-wrap end-node" [style.width.px]="diagramNodeWidth">
        <div class="node-wrap-box">
            <div class="node-wrap-body">End</div>
        </div>
    </div>
</div>
<tam-diagram-context-menu [config]="diagramContextMenu"></tam-diagram-context-menu>
<tam-diagram-conditional-gateway-dialog></tam-diagram-conditional-gateway-dialog>
<tam-diagram-note-automation-dialog></tam-diagram-note-automation-dialog>
<tam-diagram-relationship-automation-dialog></tam-diagram-relationship-automation-dialog>